import { Typography } from 'seagull';
import styles from "./DigitalSignature.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DigitalSignature(_ref) {
  let {
    formattedDigitalSignature
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles.digitalSignature,
    "data-testid": "digital-signature-block",
    children: /*#__PURE__*/_jsx("div", {
      className: styles.detailsWrapper,
      children: /*#__PURE__*/_jsxs(Typography, {
        variant: "paragraph2",
        skin: "secondary",
        testId: "digital-signature-block-when",
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.signedSignature,
          "data-testid": "digital-signature-block-signature",
          children: formattedDigitalSignature.signature
        }), ' ', formattedDigitalSignature.on, " ", formattedDigitalSignature.ip]
      })
    })
  });
}
export default DigitalSignature;